import { getStoredToken } from '@/core/auth/session/session.storage'

export function bearerTokenHook(request: Request): Request {
  const token = getStoredToken()
  if (!token) return request

  const headers = new Headers(request.headers)
  headers.set('Authorization', `Bearer ${token}`)
  return new Request(request, { headers })
}
